module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/favicon.ico
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/favicon.ico
// module chunks = 40